import React, { Component } from 'react';

class ActionBar extends Component {

    render() {
        const { handleSave, appointment, error } = this.props;

        let disabled = false;
        if (appointment === null || error || appointment.startTime === null || appointment.endTime === null || appointment.invitationTime === null) {
            disabled = true;
        }

        return (
            <footer className='request-appointment-footer'>
                <div className='request-appointment-buttons'>
                    <button onClick={e => window.location.href = '/appointments'} className='ssg-forms-btn'>Cancel</button>
                    {disabled ?
                        <button onClick={() => handleSave(appointment)} className='ssg-forms-btn ssg-forms-btn-primary' disabled={true}>Submit</button>
                        : <button onClick={() => handleSave(appointment)} className='ssg-forms-btn ssg-forms-btn-primary'>Submit</button>}
                </div>
            </footer>
        )
    }
}

export default ActionBar;


// WEBPACK FOOTER //
// src/dashboard/appointments/action-bar.js